import { isAttributeEnabledIdentifier, type IdentifiersConfig } from '@/features/people';
import { PERMANENT_ATTRIBUTES, PERMANENT_OBJECT_ATTRIBUTES, RESTRICTED_ATTRIBUTES } from '@/utils/attributes';
import { isReservedEvent } from '../utils/reserved-descriptions';
import type { DataIndexItemKind } from '../utils/types';

/**
 * Which rows a bulk action can be applied to.
 *
 * A name Customer.io owns cannot be edited or deleted, so it cannot be
 * selected either: offering the checkbox and then refusing the action is
 * worse than not offering it. Which names those are depends on the kind —
 * an object's identifiers are not a person's.
 */
export function isRowSelectable(
  kind: DataIndexItemKind,
  name: string,
  identifiers: IdentifiersConfig | null | undefined,
): boolean {
  if (kind === 'event') {
    return !isReservedEvent(name);
  }
  if (kind === 'object-attribute' || kind === 'object-relationship-attribute') {
    return !PERMANENT_OBJECT_ATTRIBUTES.includes(name);
  }
  return !(
    RESTRICTED_ATTRIBUTES.includes(name) ||
    PERMANENT_ATTRIBUTES.includes(name) ||
    isAttributeEnabledIdentifier(name, identifiers)
  );
}
